import { apiFetch } from '@/lib/http';
import type { UseCase } from '../types/onboarding';

/**
 * PATCH /auth/me — update the authenticated user's display name.
 * Called on leaving the name step before advancing.
 */
export async function saveName(name: string): Promise<void> {
  await apiFetch('/auth/me', {
    method: 'PATCH',
    body: JSON.stringify({ name }),
  });
}

/**
 * POST /auth/me/onboarding — record use-case + referral and mark onboarding
 * complete on the server. Returns the MeResponse which includes
 * onboardingCompletedAt so the client can flip the boot gate immediately.
 */
export async function completeOnboarding(input: {
  useCase: UseCase | null;
  referralSource: string | null;
}): Promise<{ onboardingCompletedAt: string | null }> {
  return apiFetch<{ onboardingCompletedAt: string | null }>('/auth/me/onboarding', {
    method: 'POST',
    body: JSON.stringify({ useCase: input.useCase, referralSource: input.referralSource }),
  });
}
